<template>
<section id="services" class="bg-white relative z-20 overflow-hidden" data-wow-delay=".2s">
  <div class="relative z-10 bg-primary overflow-hidden mb-12" style="height: 0.1rem; box-shadow: 0px -2px 5px 0px;"></div>
  <div class="absolute top-0 z-[-1]" style="left: 100px;">
    <svg width="1440" height="830" viewBox="0 0 1440 830" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity="0.5"
        d="M193.307 -273.321L1480.87 1014.24L1121.85 1373.26C1121.85 1373.26 731.745 983.231 478.513 729.927C225.976 477.317 -165.714 85.6993 -165.714 85.6993L193.307 -273.321Z"
        fill="url(#paint0_linear)"
      />
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="1308.65"
          y1="1142.58"
          x2="602.827"
          y2="-418.681"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#3056D3" stop-opacity="0.36" />
          <stop offset="1" stop-color="#F5F2FD" stop-opacity="0" />
          <stop offset="1" stop-color="#F5F2FD" stop-opacity="0.096144" />
        </linearGradient>
      </defs>
    </svg>
  </div>
  <div class="container wow fadeInUp" data-wow-delay=".2s">
    <div class="flex flex-wrap -mx-4">
      <div class="w-full px-4">
        <div class="text-center mx-auto mb-[60px] lg:mb-20 max-w-[620px]">
          <span class="font-semibold text-lg text-primary mb-2 block"> Aperçu de nos</span>
          <h2 class="font-bold text-3xl sm:text-4xl md:text-[40px] text-dark mb-4">Services</h2>
          <p class="text-lg sm:text-xl leading-relaxed sm:leading-relaxed text-body-color">
            On s'occupe de vous du début à la fin.
          </p>
        </div>
      </div>
    </div>

    <div class="flex flex-wrap items-center justify-center">
      <div class="w-full md:w-1/2 lg:w-1/3 wow fadeInUp" data-wow-delay=".25s">
        <div class="mb-8 rounded-[20px] bg-white p-10 mx-8 shadow-md hover:shadow-lg md:px-7 xl:px-10">
          <div class="mb-8 flex items-center justify-center">
            <img :src="beforeImg" alt="before-portion">
          </div>
          <h4 class="mb-3 text-xl font-semibold text-dark">
            Avant
          </h4>
          <p class="text-body-color">
            On s'assure de clarifier vos besoins et votre demande pour vous offrir le meilleur service possible, adapté à votre projet.
          </p>
        </div>
      </div>
      <div class="w-full md:w-1/2 lg:w-1/3 wow fadeInUp" data-wow-delay=".25s">
        <div class="mb-8 rounded-[20px] bg-white p-10 mx-8 shadow-md hover:shadow-lg md:px-7 xl:px-10">
              <div class="mb-8 flex items-center justify-center">
                <img :src="duringImg" alt="during-portion">
              </div>
              <h4 class="mb-3 text-xl font-semibold text-dark">
                Pendant
              </h4>
              <p class="text-body-color">
                Travail silencieux et écologique, tout en étant précis et artistique.
              </p>
            </div>
      </div>
      <div class="w-full md:w-1/2 lg:w-1/3 wow fadeInUp" data-wow-delay=".25s">
        <div class="mb-8 rounded-[20px] bg-white p-10 mx-8 shadow-md hover:shadow-lg md:px-7 xl:px-10">
              <div class="mb-8 flex items-center justify-center">
                <img :src="afterImg" alt="after-portion">
              </div>
              <h4 class="mb-3 text-xl font-semibold text-dark">
                Après
              </h4>
              <p class="text-body-color">
                On s'occupe du ramassage de feuille et de la properté de la cours avant de la quitter.
              </p>
            </div>
      </div>
    </div>
    <h2 class="font-bold mt-16 mb-4 text-center text-3xl sm:text-4xl md:text-[40px] text-dark wow fadeInUp" data-wow-delay=".15s">Ce qu'on offre</h2>
    <div class="rounded-full mx-auto cursor-pointer w-75 mb-8 bg-primary border border-[#E5E7EB] py-2 px-7 text-base font-medium
        text-center justify-center text-white transition hover:border-primary"
        @click="handleClick">
        Ouvrir la gallerie de photos
    <br/>
    </div>
    <div class="container relative wow fadeInUp" data-wow-delay=".15s">
      <div class="bg-truck -mx-4 flex flex-wrap justify-center" :style='`background-image: url(${truck})`'>
        <div class="w-75 p-4">
          <div class="mb-10 overflow-hidden rounded-lg bg-white">
            <!-- <img src="@/assets/images/services-1.jpg" data-action="zoom" alt="image"> -->
            <div class="p-8 text-left sm:p-9 md:p-7 xl:p-9 wow fadeInUp" data-wow-delay=".25s">
              <h3>
                <span class="mb-4 block text-xl font-semibold text-dark hover:text-primary sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px]">
                  Taille de Haie
                </span>
              </h3>
              <p class="mb-7 text-base leading-relaxed text-body-color">
                Taille de haie de toute sorte de variétés et de grandeur différentes.
              </p>
            </div>
          </div>
        </div>
        <div class="w-75 p-4">
          <div class="mb-10 overflow-hidden rounded-lg bg-white">
            <!-- <img src="assets/images/cards/card-01/image-02.jpg" alt="image" class="w-full"> -->
            <div class="p-8 text-center sm:p-9 md:p-7 xl:p-9 wow fadeInUp" data-wow-delay=".25s">
              <h3>
                <span class="mb-4 block text-xl font-semibold text-dark hover:text-primary sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px]">
                  Rabattage de Haie
                </span>
              </h3>
              <p class="text-base leading-relaxed text-body-color">
                Rabattage y compris l'arrachage des racines.
              </p>
            </div>
          </div>
        </div>
        <div class="w-75 p-4">
          <div class="mb-10 overflow-hidden rounded-lg bg-white">
            <!-- <img src="assets/images/cards/card-01/image-03.jpg" alt="image" class="w-full"> -->
            <div class="p-8 text-center sm:p-9 md:p-7 xl:p-9 wow fadeInUp" data-wow-delay=".25s">
              <h3>
                <span class="mb-4 block text-xl font-semibold text-dark hover:text-primary sm:text-[22px] md:text-xl lg:text-[22px] xl:text-xl 2xl:text-[22px]">
                  Installation de Haie
                </span>
              </h3>
              <p class="mb-7 text-base text-justify leading-relaxed text-body-color">
                Nous pouvons évaluer vos besoins et vous conseiller un nombre exact de haie de cèdres à planter.
                Pour plus de détail concernant les quantités, et les hauteurs disponibles, contactez-nous directement.
              </p>
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
</template>
<script>
export default {
  name: "ServicesSection",
  methods: {
    handleClick() {
      let itemsToShow = this.imageList.map(url => {
        return {
          src: url
        }
      });
      this.$Pswp.open({ items: itemsToShow });
    }
  },
  mounted() { },
  data() {
    return {
      truck: require('@/assets/images/truck.jpg'),
      beforeImg: require('@/assets/images/services/before.png'),
      duringImg: require('@/assets/images/services/during.png'),
      afterImg: require('@/assets/images/services/after.png'),
      imageList: [
        require('@/assets/images/gallery/1.jpg'),
        require('@/assets/images/gallery/2.jpg'),
        require('@/assets/images/gallery/3.jpg'),
        require('@/assets/images/gallery/4.jpg'),
        require('@/assets/images/gallery/5.jpg'),
        require('@/assets/images/gallery/6.jpg'),
        require('@/assets/images/gallery/7.jpg'),
      ]
    };
  },
  computed: { },
};
</script>
<style lang="scss">
.bg-truck {
  background-size: cover;
  min-height: 620px;
  border-radius: 30px;
}
</style>
